var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageWrapDefault',{attrs:{"baseClass":"none","hidePageTitle":true,"showBack":false,"showBreadcrumbs":false,"hideInfoMessage":false}},[_c('div',[_c('WidgetWelcome')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }